import type {ReactElement} from 'react';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {SaveStatusBadge} from '../save-status-badge/save-status-badge';
import {ICON_VERSION_HISTORY} from './save-status-version-history-swap.types';
import type {SaveStatusVersionHistorySwapProps} from './save-status-version-history-swap.types';
import styles from './save-status-version-history-swap.module.scss';

export function SaveStatusVersionHistorySwap({savedIcon, savedLabel, onOpenVersionHistory}: SaveStatusVersionHistorySwapProps): ReactElement {
  return (
    <ClickableDiv className={styles.swap} onClick={onOpenVersionHistory} aria-label={window.i18next.t('pmwjs_view_version_history')}>
      <span className={`${styles.layer} ${styles.saved}`} aria-hidden>
        <SaveStatusBadge icon={savedIcon} label={savedLabel} />
      </span>
      <span className={`${styles.layer} ${styles.versionHistory}`} aria-hidden>
        <SaveStatusBadge icon={ICON_VERSION_HISTORY} label={window.i18next.t('pmwjs_view_version_history')} />
      </span>
    </ClickableDiv>
  );
}
